const SlideUpAnimation = {
	"data-sal": "slide-up",
	"data-sal-duration": "1000",
	"data-sal-easing": "ease-out",
}

export default SlideUpAnimation
